export default __webpack_public_path__ + "static/media/2C.276c3f69.svg";